var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestRates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#134A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.667 12h-8a.345.345 0 00-.237.097L11.097 23.43a.336.336 0 000 .473l8 8a.337.337 0 00.473 0L30.903 20.57a.345.345 0 00.097-.237v-8a.334.334 0 00-.333-.333zM27 17.667a1.668 1.668 0 11.002-3.336A1.668 1.668 0 0127 17.667z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
export default SvgBestRates;